import { render, staticRenderFns } from "./help_open_tutorial.vue?vue&type=template&id=bd9ff5ca&scoped=true&"
import script from "./help_open_tutorial.vue?vue&type=script&lang=js&"
export * from "./help_open_tutorial.vue?vue&type=script&lang=js&"
import style0 from "./help_open_tutorial.vue?vue&type=style&index=0&id=bd9ff5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ff5ca",
  null
  
)

export default component.exports